import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { WHATSAPP_LINK } from "../lib/api";
import { FlagPair } from "./Brand";
import { useContent } from "../context/ContentContext";

export const CtaBanner = () => {
  const { cta } = useContent();
  return (
    <section className="bg-white px-4 pb-24 sm:px-6 lg:px-8" data-testid="cta-banner">
      <Reveal className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-3xl bg-navy px-6 py-14 shadow-2xl shadow-navy/30 sm:px-14">
          <div className="absolute -left-16 -top-16 h-64 w-64 rounded-full bg-brandred/20 blur-3xl" />
          <div className="absolute -bottom-20 -right-10 h-72 w-72 rounded-full bg-gold/15 blur-3xl" />
          <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white">
                <FlagPair /> {cta.badge}
              </span>
              <h2 className="mt-5 font-display text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
                {cta.title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-white/70">{cta.desc}</p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
              <a
                href="/#quote"
                data-testid="cta-quote-btn"
                className="inline-flex items-center justify-center gap-2 rounded-xl bg-brandred px-7 py-4 text-base font-bold text-white shadow-lg shadow-brandred/40 transition-transform hover:bg-brandred-700 active:scale-95"
              >
                Get a Quote <ArrowRight size={18} />
              </a>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noreferrer"
                data-testid="cta-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/25 bg-white/5 px-7 py-4 text-base font-bold text-white backdrop-blur transition-colors hover:bg-white/15"
              >
                <MessageCircle size={18} /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
